import { Box, Typography } from "@material-ui/core";
import { useEffect, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { CHAIN_ALIASES } from "src/wallet-connection/chains";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";
import CssSelector from "./CssSelector";

const config = {
  "trava-bsc": { value: "trava-bsc", label: "TRAVA BSC" },
  "trava-ftm": { value: "trava-ftm", label: "TRAVA FTM" },
  "trava-eth": { value: "trava-eth", label: "TRAVA ETH" },
};

export default function PoolSelector({ rootUrl, ...props }) {
  const { pool } = useParams();
  const history = useHistory();
  const { address, chain } = useWeb3Connect();

  const onPoolChange = (_, pool) => {
    history.push(`${rootUrl}/${pool.value}`);
  };

  const poolConfig = useMemo(() => {
    if (address && chain.chainId) {
      if (chain.chainId === CHAIN_ALIASES.BSC_MAINNET) return [config["trava-bsc"]];
      else if (chain.chainId === CHAIN_ALIASES.FTM_MAINNET) return [config["trava-ftm"]];
      else if (chain.chainId === CHAIN_ALIASES.ETH_MAINNET) return [config["trava-eth"]];
      else return [];
    }
    return Object.values(config);
  }, [address, chain.chainId]);

  useEffect(() => {
    if (poolConfig.length > 0) onPoolChange(null, poolConfig[0]);
  }, [rootUrl, poolConfig]);

  return (
    <Box display="flex" alignItems="center" {...props}>
      <Typography color="textSecondary">Pool</Typography>
      <CssSelector
        ml={1}
        value={config[pool]?.label}
        defaultSelectedItem={config[pool]}
        event={{ onChooseItem: onPoolChange }}
        config={poolConfig}
      />
    </Box>
  );
}
